import { ContractRenewal, RequestContractRenewal } from '../models/interface-contract-renewal';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ClientData } from '../models/interface-client-data';
import { ClientService } from './client.service';
import { Contract } from '../models/interface-contract';
import { ContractDetails } from '../models/interface-contract-details';
import { GlobalService } from '../services/global.service';
import { HistoricRenovation } from '../models/interface-historic-renovation';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class PrivateAreaService {

    showContract: boolean;
    showPersonalData: boolean;
    showHistoricRenovation: boolean;

    constructor(private httpClient: HttpClient, private clientService: ClientService, private globalService: GlobalService) {
        this.showContract = true;
        this.showPersonalData = false;
        this.showHistoricRenovation = false;
    }

    getActiveContracts(): Observable<Contract[]> {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        return this.httpClient.get<Contract[]>(`${this.globalService.urlApiParam}/api/clientes/contratosvigor`, { headers });
    }

    getAllContracts(): Observable<Contract[]> {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        return this.httpClient.get<Contract[]>(`${this.globalService.urlApiParam}/api/clientes/listallcontratos`, { headers });
    }

    getClientData() {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        return this.httpClient.get<ClientData>(`${this.globalService.urlApiParam}/api/clientes/me`, { headers });
    }

    requestContractRenewal(idContract) {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        const body = {
            codContrato: idContract
        };
        return this.httpClient.post<RequestContractRenewal>(`${this.globalService.urlApiParam}/api/clientes/requestrenovacion`, body, { headers });
    }

    ContractRenewal(idContract, sequence) {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        const body = {
            codContrato: idContract,
            sequence
        };
        return this.httpClient.post<ContractRenewal>(`${this.globalService.urlApiParam}/api/clientes/tpvrenovar`, body, { headers });
    }

    GetContractData(idContract) {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        const body = {
            codContrato: idContract
        };
        return this.httpClient.post<ContractDetails>(`${this.globalService.urlApiParam}/api/clientes/getcontratoinfo`, body, { headers });
    }

    getHistoricRenovation(codContract): Observable<HistoricRenovation[]> {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        const body = {
            codContrato: codContract
        };
        return this.httpClient.post<HistoricRenovation[]>(`${this.globalService.urlApiParam}/api/clientes/getallrenovaciones`, body, { headers });
    }

    getRenovationBill(codFacturation) {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        const body = {
            codFacturaRenovacion: codFacturation
        };
        return this.httpClient.post(`${this.globalService.urlApiParam}/api/clientes/getPdfFacturaRenovacion`, body, {
            headers,
            responseType: 'blob'
        });
    }

    getContract(codContract) {
        this.clientService.refreshToken();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.clientService.getToken()}`
        });
        const body = {
            codContrato: codContract
        };
        return this.httpClient.post(`${this.globalService.urlApiParam}/api/clientes/getPdfUltimaRenovacion`, body, {
            headers,
            responseType: 'blob'
        });
    }

    gpPaymentResult(url, evtdata, success, error ) {
        const body = new URLSearchParams();
        body.set('hppResponse', JSON.stringify( evtdata));
        this.httpClient.post(url, body.toString(),
        {
          headers: new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded'),
            responseType: 'text'
        }).subscribe(
            (data) => {
                success(data);
            }, (err) => {
                error(err);
            }
        );
    }
}
